export default "__VITE_ASSET__Duj2TWvs__"